import { ChangeDetectionStrategy, Component, HostBinding, Input, ViewEncapsulation } from '@angular/core';
import { FiStateNames } from '../../../fi-state-proxy/fi-state-names';
import { FiWrapperTableAdditionalColumns } from '../../../fi-wrapper-table/fi-wrapper-table-additional-columns';
import { IChecklistV2ForList } from '../../checklist-v2';
import { DetectDevicesService } from '../../../fi-shared-services';
import { FiChecklistHelperService } from '../../fi-checklist-helper.service';
import { FiNotificationHelperService } from '../../../fi-notification/fi-notification-helper.service';
import { ChecklistViewerStatus } from '../../fi-checklist-viewer-status';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { RawParams } from '@uirouter/angular';

@Component({
    selector: 'fi-checklist2-list-name',
    templateUrl: './fi-checklist2-list-name.component.html',
    styleUrls: ['./fi-checklist2-list-name.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-checklist2-list-name' },
    providers: [{ provide: FiWrapperTableAdditionalColumns, useExisting: FiChecklist2ListNameComponent }],
    standalone: false,
})
export class FiChecklist2ListNameComponent extends FiWrapperTableAdditionalColumns {
    @Input({ required: true }) auditMode: boolean;
    @Input() extendedSearchMode: boolean;
    @Input() allUnitsMode: boolean;
    @Input() checkActiveByScheduleRights: boolean; // audit checklists top table mode https://chainformation.atlassian.net/browse/FI-5677

    protected readonly FiStateNames = FiStateNames;

    constructor(
        private detectDevicesService: DetectDevicesService,
        private fiChecklistHelperService: FiChecklistHelperService,
        private notificationHelper: FiNotificationHelperService,
        private fiStateService: FiStateService,
    ) {
        super();
    }

    @HostBinding('class.mobile-view') get isMobileView(): boolean {
        return this.detectDevicesService.isMobilePhone();
    }

    isNotVisited(item: IChecklistV2ForList) {
        return this.notificationHelper.isNotVisited(item);
    }

    isActive(item: IChecklistV2ForList) {
        if (this.checkActiveByScheduleRights) {
            return item.HasAccessToSchedule;
        }
        const viewerStatus = this.fiChecklistHelperService.getViewerStatus(item);
        // https://chainformation.atlassian.net/browse/FI-6048
        if (viewerStatus === ChecklistViewerStatus.OnDemandReadyToStart) {
            return item.HasAccessToSchedule;
        }
        return viewerStatus === ChecklistViewerStatus.Active || this.allUnitsMode;
    }

    getViewState(item: IChecklistV2ForList): string {
        return this.fiChecklistHelperService.getChecklistViewState(item, this.auditMode);
    }

    getViewStateParams(item: IChecklistV2ForList): RawParams {
        return this.fiChecklistHelperService.getChecklistViewStateParams(item, this.auditMode);
    }

    onClick($event: MouseEvent, item: IChecklistV2ForList) {
        $event.preventDefault();
        this.fiChecklistHelperService.onChecklistListItemClick(item, this.auditMode);
    }
}
